export enum FrameworkServiceType {
    HEALTH = 'health',
    METADATA = 'metadata',
    LIST_ASSET_INFOS = 'asset-info',
}
